export const sessionTimeOut = Object.freeze({
  logoutTime: 1000 * 60 * 60,
  warningTime: 1000 * 60 * 55,
  countDownTime: 1000 * 60 * 5,
});
